import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class EstimatesAdded extends Component {
  getColumns = () => {
    return [
      {
        title: 'Project Name',
        dataIndex: 'project_name'
      },
      {
        title: 'Estimate ID',
        dataIndex: 'id'
      },
      {
        title: 'Descritpion',
        dataIndex: 'description'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { estimatesAddedData } = this.props

    const data = estimatesAddedData.map((estimate, index) => {
      // format date from db
      estimate.created_date = moment(new Date(estimate.created_date)).format('YYYY-M-D h:mm a')

      // format project name
      estimate.project_name = estimate.job_name ? estimate.job_name : estimate.lead_name

      // format primary contact name
      estimate.primary_contact = `${estimate.contact_first_name} ${estimate.contact_last_name}`

      const returnObj = Object.assign({ key: `${estimate.id}${index}` }, estimate)
      return returnObj
    })
    return data
  }

  render() {
    const { loadingEstimatesAdded, estimatesAddedData } = this.props
    return (
      <div>
        {loadingEstimatesAdded && !estimatesAddedData && <Spin />}
        {!loadingEstimatesAdded &&
          estimatesAddedData && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default EstimatesAdded



// WEBPACK FOOTER //
// ./src/components/reports/general/activity-report/EstimatesAdded.js